module.exports = __webpack_public_path__ + "hinted-OpenSansLight-Italic.b35dc58eb070d9c952f2.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.eot
// module chunks = 1